import { useParams } from "react-router-dom";

export const useMenuIdFromURL = () => {
  const { menuId } = useParams<{ menuId: string }>();

  return menuId;
};
